export const downloadUrl = `//slsimoti.bg/files/download.php?file=`;



// WEBPACK FOOTER //
// ./src/config.js